import {createAddSlice} from "../genericCrudSlice";
import {addWalletApi} from "../../api/entities/wallets";


const createWalletSlice = createAddSlice('wallet', addWalletApi);
export const {init: initCreateWallet} = createWalletSlice.actions;
export const {addEntity: createWallet} = createWalletSlice;
export default createWalletSlice.reducer;